import { config } from '@src/config';
import { cn } from '@src/lib/utils';
import { resources } from '@src/resources';

interface EnrichmentLogoProps {
  size?: number;
  showText?: boolean;
  className?: string;
}

export function EnrichmentLogo({ size = 26, showText = false, className }: EnrichmentLogoProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <div
        className="flex shrink-0 items-center justify-center rounded-lg bg-primary font-bold text-primary-foreground"
        style={{ width: size, height: size, fontSize: size * 0.5 }}
      >
        E
      </div>
      {showText && (
        <div>
          <div className="text-[13px] font-semibold tracking-tight text-foreground">{resources.common.appName}</div>
          <div className="text-[10.5px] text-muted-foreground">really-enrich &middot; {config.environment.name}</div>
        </div>
      )}
    </div>
  );
}
